import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import { Subject, Subscription } from 'rxjs';
import { DelayedRecallResult, EvaluationCallBackResult, GameResult } from 'src/app/games/shared/gameResult';
import { AuthenticationService } from 'src/app/services/authentication.service';
import messagesHu from 'node_modules/devextreme/localization/messages/hu.json';
import { loadMessages, locale } from 'devextreme/localization';
import { LoginUser } from 'src/app/services/webapiclient.service';
import { GameService } from 'src/app/games/services/game.service';

@Component({
    selector: 'app-anterograd-eva',
    templateUrl: './anterograd-eva.component.html',
    styleUrl: './anterograd-eva.component.scss',
    standalone: false
})

export class AnterogradEvaComponent implements OnInit, OnDestroy {
  @Input() wrResult: DelayedRecallResult;
  @Input() gameId: number;
  @Input() gameType: string;
  @Input() needSaveSubject:Subject<any>;
  @Output() closeEvaluationEvent = new EventEmitter<EvaluationCallBackResult>();

  private translSubs$: Subscription;
  private needSaveSubject$: Subscription;
  stylingMode = "filled"
  currentUser: LoginUser;
  error: any;
  dateFormat: string;
  lang: string;

  gameResult: GameResult = <GameResult>{};
  callBackResult: EvaluationCallBackResult = <EvaluationCallBackResult>{};


  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private translation: L10nTranslationService,
    private authenticationService: AuthenticationService,
    public gameService: GameService

  ) {
    const huMessages = JSON.stringify(messagesHu['hu']);
    loadMessages({
      'hu': JSON.parse(huMessages)
    });
  }


  ngOnInit(): void {
    this.needSaveSubject$ = this.needSaveSubject.subscribe(event => {
      // called when the notifyChildren method is
      // called in the parent component
      this.saveData(event);
      //console.log(event);
    });

    this.translSubs$ = this.translation.onChange().subscribe(
      x => {
        locale(x.language);
        this.lang = x.language;
        this.dateFormat = this.translation.translate('Core.DateFormat');
      });

    this.currentUser = this.authenticationService.currentUserValue;

    if (this.currentUser) {
      //this.evaluation = true;
    }
  }

  ngOnDestroy() {
    if (this.translSubs$) {
      this.translSubs$.unsubscribe();
    }
    if(this.needSaveSubject$){
      this.needSaveSubject$.unsubscribe();    
    }
  }

  saveData(direction) {

    //Lementjük a tesztet .pmg képként is a feladatlap riporthoz
    //this.uploadTestImage();
    this.error = null;
    let tmpResult = 0;

 
    // A szerver számára összeállítjuk az adatokat.
    tmpResult = this.wrResult.recallRounds[2].guessWords.filter(f => f.correct).length;  
    if(this.gameType == "AKV"){
      //AKV esetén minden fordulót pontozunk
      tmpResult = tmpResult + this.wrResult.recallRounds[0].guessWords.filter(f => f.correct).length;  
      tmpResult = tmpResult + this.wrResult.recallRounds[1].guessWords.filter(f => f.correct).length;
      if(this.wrResult.recallRounds[3]){
        //Utolsó forduló eredménye
        this.wrResult.result1 = this.wrResult.recallRounds[3].guessWords.filter(f => f.correct).length;
      }  
    }  


    this.wrResult.evaluation = true;
    this.gameResult.result = tmpResult + this.wrResult.result1 + this.wrResult.result2;
    this.gameResult.resultDetails = JSON.stringify(this.wrResult);
    this.gameResult.subType = "Anterograd";
    this.gameResult.completed = true;
    this.gameResult.id = this.gameId;

    // Elküldjük a szerverre az adatokat.
    this.gameService.send(this.gameResult).subscribe(
      () => {
        //Jelezzük a hívónak, hogy vége a kiértékelésnek
        this.callBackResult.direction = direction;
        this.callBackResult.result = this.gameResult.result;
        this.closeEvaluationEvent.emit(this.callBackResult);
       }
    );

  }


}
